export default __webpack_public_path__ + "static/devOps-4625be9f993591b39c7df4c734a8c9cc.svg";